import { render, staticRenderFns } from "./ProfitChart.vue?vue&type=template&id=2e993dbb&scoped=true&lang=pug&"
import script from "./ProfitChart.vue?vue&type=script&lang=js&"
export * from "./ProfitChart.vue?vue&type=script&lang=js&"
import style0 from "./ProfitChart.vue?vue&type=style&index=0&id=2e993dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e993dbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDivider,VRow})
